import "./ContributionManagmentTable.scss";

// @vendors
import React from 'react';
import { PropTypes } from 'prop-types';
const classNames = require('classnames');
const { getLastNChars } = require('utilities/stringHelper');

// @commons
const { OKTable } = require("commonsComponents/OKTable");
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @components
import ContributionManagmentRow from '../ContributionManagmentRow/ContributionManagmentRow';

// @helpers
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
import { i18n } from 'core/i18n';
const { formatText } = i18n;

const ContributionManagmentTable = ({periodicalFundsContributions, expandRowId}) => {

    let rows = null;

    const buildCell = (item) => {
        const {
          currencyCode,
          amount,
          periodicity,
          contractCode,
          marketName,
          foundAmount,
          foundCurrency,
          nameHolder,
        } = item;
        const last4ContractCode = getLastNChars(contractCode, 4, '');
        const periodicalContributionCurrency = formatCurrency(currencyCode ? currencyCode : 'EUR');
        const periodicalContributionAmount = formatWithoutRound(amount, 2);
        const fCurrency = formatCurrency(foundCurrency ? foundCurrency : 'EUR');
        const fAmount = formatWithoutRound(foundAmount, 2);
        const formatAmount = `${periodicalContributionAmount} ${periodicalContributionCurrency}`;
        const foundValue = `${fAmount} ${fCurrency}`;
        return (
           <React.Fragment>
                <OKTableCell><strong>{marketName}</strong>...{last4ContractCode}</OKTableCell>
                <OKTableCell>{foundValue}</OKTableCell>
                <OKTableCell>{nameHolder}</OKTableCell>
                <OKTableCell>{periodicity ? formatText('brokerWealth-contributionManagment'+periodicity) : '-' }</OKTableCell>
                <OKTableCell>{amount ? formatAmount : '-'}</OKTableCell>
           </React.Fragment>
        )
    }

    const headersData = [
        { className: 'broker-contribution-managment-activity__collapsables' },
        {   className: 'broker-contribution-managment-activity__description',
            component: formatText('brokerWealth-contributionManagmentContract'),
            },
        {
            className: 'broker-contribution-managment-activity__order',
            component: formatText('brokerWealth-contributionManagmentActualAmount'),
        },
        {
            className: 'broker-contribution-managment-activity__value',
            component: formatText('brokerWealth-contributionManagmentOwner'),
        },
        {
            className: 'broker-contribution-managment-activity__operation',
            component: formatText('brokerWealth-contributionManagmentPeriodicity'),
        },
        {
            className: 'broker-contribution-managment-activity__state',
            component: formatText('brokerWealth-contributionManagmentAmount'),
        },
        { clear: true }
    ];

    const columnsHeader = headersData.map((column, index) => {
        return (
            <OKTableCell asHeader={true} key={index} className={column.className || ''}>
                {column.component}
            </OKTableCell>
        );
    });

    if (periodicalFundsContributions) {
        rows = periodicalFundsContributions.map((item) => {
           const children = buildCell(item)
           return (
             <ContributionManagmentRow
               children={children}
               index={item.contractCode}
               data={item}
               expandRowId={expandRowId}
             />
           );
       })
   }

   let classes = classNames('contributions-table');

    return (
        <OKTable className={classes} id={1} >
            <thead>
                <OKTableRow asHeader={true}>
                    {columnsHeader}
                </OKTableRow>
            </thead>
            {rows}
        </OKTable>
    )

}

ContributionManagmentTable.propTypes = {
    periodicalFundsContributions: PropTypes.object.isRequired,
}

export default ContributionManagmentTable;
